import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Alert} from "@mui/material";
import {FinishAuthenticationFlowFunction, HandleLoginFunction} from "../auth/authentication";

interface LoginCallbackPageProps {
    handleLogin: HandleLoginFunction,
    finishAuthenticationFlow: FinishAuthenticationFlowFunction
}

function LoginCallbackPage({handleLogin, finishAuthenticationFlow}: LoginCallbackPageProps): JSX.Element {
    const [error, setError] = useState<null | boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        finishAuthenticationFlow().then(user => {
            handleLogin(user, navigate);
        }).catch(() => {
            setError(true);
        });
    });

    return <div>
        {error &&
            <Alert severity="error">Failed to finish login</Alert>
        }
    </div>;
}

export default LoginCallbackPage;
